module.exports = __webpack_public_path__ + "static/media/08.99492839.jpg";